<template>
  <div id="bigButton">
    <button :disabled="isClick" class="buttons" :class="{'button_click': isClick}" @click="buttonClick">
    </button>
  </div>
</template>

<script>
export default {
  name: "bigButton",
  data() {
    return {
      isClick: false
    };
  },
  methods: {
    buttonClick() {
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false;
        this.click();
      }, 100);
    }
  },
  props: ["click"]
};
</script>

<style lang="scss">
#bigButton {
  margin-top: 80px;
  .buttons {
    display:block;
    width: 290px;
    height:87px;
    background:url('../assets/img/btn_bg.png') no-repeat 0 0 / 100% 100%;
    margin:0 auto;
    &.button_click {
      transform-origin: center;
      transform: scale(0.9);
    }
  }
}
</style>
